export default __webpack_public_path__ + "static/media/dummy-lessmore-GRAPH.86c9a593.png";